import { Trans } from "@lingui/react/macro";
import React from "react";
import * as styles from "./CruiseRecapColumns.module.scss";
import DateOnlyFormat from "components/DateOnlyFormat";
import CruiseRecapItem from "./CruiseRecapItem";
import clsx from "clsx";
import CruiseDuration from "components/cruises/CruiseDuration";
import {
  CruiseEventTagsContent,
  CruiseEventTagsTitle
} from "src/page-components/cruise/CruiseInfoSummary/CruiseEventTags/CruiseEventTags";

interface CruiseRecapColumnsProps {
  shipName?: string;
  departureDate?: string;
  arrivalDate?: string;
  duration?: number;
  layout?: "auto" | "auto-wide" | "grid";
  className?: string;
  cruiseTags?: string[];
}

const CruiseRecapColumns: React.FC<
  React.PropsWithChildren<CruiseRecapColumnsProps>
> = ({
  className,
  shipName,
  departureDate,
  arrivalDate,
  duration,
  cruiseTags,
  layout = "auto"
}) => {
  return (
    <div
      className={clsx(styles.cruiseRecap, className, {
        [styles.cruiseRecapAuto]: layout == "auto",
        [styles.cruiseRecapGrid]: layout == "grid",
        [styles.cruiseRecapAutoWide]: layout == "auto-wide"
      })}
    >
      <dl>
        {departureDate && (
          <CruiseRecapItem
            title={
              <React.Fragment>
                <Trans>Cruise starts</Trans>{" "}
              </React.Fragment>
            }
            value={
              <DateOnlyFormat
                value={departureDate}
                format={{
                  year: "numeric",
                  month: "short",
                  day: "numeric"
                }}
              />
            }
          />
        )}
        {arrivalDate && (
          <CruiseRecapItem
            title={<Trans>Cruise ends</Trans>}
            value={
              <DateOnlyFormat
                value={arrivalDate}
                format={{
                  year: "numeric",
                  month: "short",
                  day: "numeric"
                }}
              />
            }
          />
        )}

        <CruiseRecapItem
          title={<Trans>Duration</Trans>}
          value={<CruiseDuration days={duration || 0} />}
        />

        {shipName && (
          <CruiseRecapItem title={<Trans>Ship</Trans>} value={shipName} />
        )}

        {cruiseTags && cruiseTags.length > 0 && (
          <CruiseRecapItem
            title={<CruiseEventTagsTitle />}
            value={<CruiseEventTagsContent cruiseTags={cruiseTags} />}
            className={styles.cruiseEventTagsWrapper}
          />
        )}
      </dl>
    </div>
  );
};

export default React.memo(CruiseRecapColumns);
